window.bootstrap = require('bootstrap');

import "@fortawesome/fontawesome-free/js/all";



/*#########################################################
    モーダル表記
#########################################################*/
window.modal = new bootstrap.Modal(document.getElementById('modal'));
window.make_modal = ({
    title = null,
    body = null,
    footer = null }) => {
    const $modal = document.getElementById('modal');
    $modal.addEventListener('show.bs.modal', function (event) {
        $modal.querySelector('#modal_title').innerHTML = title;
        $modal.querySelector('#modal_body').innerHTML = body;
        $modal.querySelector('#modal_footer').innerHTML = footer;
    }, { once: true });
    modal.show();
}
window.close_modal = ({ callback = null }) => {
    modal.hide();
    const $modal = document.getElementById('modal');
    $modal.addEventListener('hidden.bs.modal', function (event) {
        $modal.querySelector('#modal_title').innerHTML = null;
        $modal.querySelector('#modal_body').innerHTML = null;
        $modal.querySelector('#modal_footer').innerHTML = null;
        if (callback) {
            return callback();
        }
    }, { once: true });
}

/*#########################################################
    フォーム処理
#########################################################*/
const api = "./assets/api/smtp_mail.php";
const form = document.getElementById('form');

// バリデーション
window.check = () => {
    let formdata = get_data();
    formdata.set('mode', 'check');
    return fetch(
        api,
        {
            method: "POST",
            body: formdata,
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            validate_reset();
            if (data.error) {
                if (data.validation.length !== 0) {
                    return validate(data.validation);
                } else {
                    throw new Error(response.statusText);
                }
            }
            return confirm(data.inputs);
        })
        .catch(error => {
            return make_modal({
                title: 'エラー',
                body: 'エラーが発生しました。<br />' + error.message,
            });
        });
}

// 確認出力
const confirm = (inputs) => {
    inputs = Object.keys(inputs).map(function (key) {
        return inputs[key];
    }).sort(function (a, b) {
        return (a.order < b.order) ? -1 : 1;  //オブジェクトの昇順ソート
    });
    let title = "確認";
    let body = "下記の内容で送信してよろしいですか？";
    body += "<table class='table my-3'>";
    for (const item in inputs) {
        // 隠し要素は確認画面に出さない
        if (inputs[item].type !== "hidden") {
            body += "<tr><th class='small'>" + inputs[item].label + "</th><td>" + inputs[item].value + "</td></tr>";
        }
    }
    body += "</table>";
    let footer = "<button type='button' class='btn btn-bordered btn-bordered-danger px-5' onclick='send();'>送信する <i class='far fa-paper-plane'></i></button>";
    make_modal({ title, body, footer });
}

// メール送信
window.send = () => {
    let formdata = get_data();
    const send_btn = document.querySelector('[onclick="send();"'); // 送信ボタン
    const send_btn_text = send_btn.innerHTML; // 送信ボタンの送信前テキスト
    const sending_text = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>送信中…`; // 送信中テキスト
    send_btn.disabled = true; // 送信ボタンを無効化
    send_btn.innerHTML = sending_text; // 送信中テキストを表示
    formdata.set('mode', 'send');
    return fetch(
        api,
        {
            method: "POST",
            body: formdata,
        })
        .then(response => {
            send_btn.disabled = false; // 送信ボタンを有効化
            send_btn.innerHTML = send_btn_text; // 送信前テキストを表示
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            console.log(data);
            validate_reset();
            if (data.error) {
                if (data.validation.length !== 0) {
                    return validate(data.validation);
                } else if (data.message) {
                    throw new Error(data.message);
                } else {
                    throw new Error(response.statusText);
                }
            }
            return close_modal({ callback: success });
        })
        .catch(error => {
            close_modal({ callback: null});
            alert("エラーが発生しました。\n" + error.message);
        });
}

// フォームタグの内容と送信内容を取得
const get_data = () => {
    let formdata = new FormData(form);
    let inputs = {};
    let order = 1;
    for (const item of form.querySelectorAll('[name]')) {
        let name = item.getAttribute('name');
        let required = (item.getAttribute('required') == null) ? false : true;
        let id = item.getAttribute('id');
        if (name.indexOf('[]') !== -1) {
            name = name.replace('[]', '');
            formdata.set('inputs[' + name + '][name]', name);
            formdata.set('inputs[' + name + '][required]', required);
            formdata.set('inputs[' + name + '][id]', id);
            formdata.set('inputs[' + name + '][order]', order);
        } else {
            formdata.append('inputs[' + name + '][name]', name);
            formdata.append('inputs[' + name + '][required]', required);
            formdata.append('inputs[' + name + '][id]', id);
            formdata.append('inputs[' + name + '][order]', order);
        }

        if (item.tagName == "INPUT") {
            formdata.append('inputs[' + name + '][type]', item.getAttribute('type').toLowerCase());
        } else {
            formdata.append('inputs[' + name + '][type]', item.tagName.toLowerCase());
        }
        order++;
    }

    // ラベルを取得して合体
    for (const item of form.querySelectorAll('label')) {
        if (item.classList.contains('form-check-label') == false) {
            let text = item.innerText;
            // let _for = item.getAttribute('for');
            let _for = item.getAttribute('for').replace('[]', '');
            formdata.append('inputs[' + _for + '][label]', text);
        }
    }
    return formdata;
}

// バリデーションの表示
const validate = (validation) => {
    let i = 0;
    for (const name in validation) {
        if (i == 0) {
            document.getElementById(name).focus();
        }
        let input = document.getElementById(name);
        input.classList.add("is-invalid");
        input.nextElementSibling.innerHTML = validation[name].join("<br>");
        i++;
    }
}

// バリデーションの初期化
const validate_reset = () => {
    let inputs = document.querySelectorAll(".is-invalid");
    inputs.forEach(function (input) {
        input.classList.remove("is-invalid");
    });
    // フィードバックの初期化
    let feedbacks = document.querySelectorAll(".invalid-feedback");
    feedbacks.forEach(function (feedback) {
        feedback.innerHTML = "";
    });
}

window.success = () => {
    form.reset();
    location.href = './thanks';
}
